import React from "react";

import { Permissions } from "@/lib/permissions";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";

import SigurnosnePoruke from "@/models/sigurnosne_poruke";
import SigurnosnaPodrucja from "@/models/sigurnosna_podrucja";

import SigurnosnaPodrucjaDialog from "./SigurnosnaPodrucjaDialog"
import SigurnosnaPorukaDialog from "../SigurnosnePorukePage/SigurnosnaPorukaDialog";

function SigurnosnaPodrucjaPage() {
  return (
    <DataCentricPage
      needPermission={[Permissions.Administration]}

      primaryModel={SigurnosnaPodrucja}
      primaryTitleToken="menu.sigurnosna_podrucja"
      primaryView={"default"}
      primaryAllowAdd={true}
      primaryAllowView={true}
      primaryAllowEdit={true}
      primaryDialogComponent={SigurnosnaPodrucjaDialog}
      primaryDialogForm={"default"}

      secondaryModel={SigurnosnePoruke}
      secondaryTitleToken="titles.sigurnosne_poruke"
      secondaryView={"default"}
      secondaryAllowView={true}
      secondaryAllowEdit={true}
      secondaryDialogComponent={SigurnosnaPorukaDialog}
      secondaryDialogForm={"default"}

      baseRecordPath={SigurnosnaPodrucja.apiPath}
      childRecordRelativePath="sigurnosne-poruke"
      geomRelativePath="geom"

      mapId={6}
      mapModel={SigurnosnaPodrucja}
    />
  );
}

export default SigurnosnaPodrucjaPage;
